import React, { createContext, useContext, useEffect, useState } from 'react';
import { useStorage } from '~Components/Storage';
import { useBridgeApi, useLogger, useSelector } from '~Hooks';

interface ContextType {
  open: () => void;
  isOpen: boolean;
}

interface ProviderProps {
  children: React.ReactNode;
}

const Context = createContext<ContextType>({} as ContextType);

export const useCashDrawer = () => useContext(Context);

export default function CashDrawerProvider({ children }: ProviderProps) {
  const logger = useLogger('cash-context');
  const bridgeApi = useBridgeApi();
  const [storage] = useStorage();
  const [isOpen, setIsOpen] = useState(false);
  const printers = useSelector((state) => state.printers);
  const primaryPrinter = printers.find((printer) => printer.primary);

  // const checkIfOpen = async () => {
  //   if (!primaryPrinter) {
  //     return false;
  //   }

  //   /* We currently don't have support for cash drawers for cloud printers since cloud print don't go through order-manager-app */
  //   if (primaryPrinter.model === 'StarCloudPrinter') {
  //     return false;
  //   }

  //   try {
  //     const statuses = await bridgeApi.getPrinterStatus(primaryPrinter.id);
  //     return statuses.drawerIsOpen;
  //   } catch (error) {
  //     logger.info('Failed to get printer status.', { errorObject: error });
  //     return false;
  //   }
  // };

  // const startInterval = () => {
  //   const intervalId = setInterval(async () => {
  //     const drawerIsOpen = await checkIfOpen();
  //     setIsOpen(drawerIsOpen);
  //     if (!drawerIsOpen) {
  //       clearInterval(intervalId);
  //     }
  //   }, 2000);
  //   return intervalId;
  // };

  // useEffect(() => {
  //   let intervalId: number | undefined;

  //   if (isOpen) {
  //     intervalId = startInterval();
  //   }

  //   return () => {
  //     if (intervalId) {
  //       clearInterval(intervalId);
  //     }
  //   };
  // }, [isOpen, primaryPrinter]);

  const open = async () => {
    if (storage.disableCash) {
      logger.info('Cash drawer is disabled.');
      return;
    }

    if (!primaryPrinter) {
      logger.info('No primary printer found.');
      return;
    }

    if (primaryPrinter.model === 'StarCloudPrinter') {
      logger.info('No primary printer found.');
      return;
    }

    logger.info('Calling open cash drawer.');
    await bridgeApi.kickOutDrawer();
    // setIsOpen(true);
  };

  const contextValue = {
    open,
    isOpen,
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
}
